import React from "react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import validationSchema from "../ValidationScheema/Yup";
import { signupUser } from "../Store/api/auth";
import { Link, useNavigate } from "react-router-dom";
import SideBar from "./SideBar";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../components/Loader";
import storage from "../services/storage";
import DraggableSidebar from "../components/DraggableSidebar";
const initialValues = {
  firstName: "",
  lastName: "",
  // phonenumber: "",
  email: "",
  password: "",
  confirmPassword: "",
};

function StudentSignup() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [errorMessage, setErrorMessage] = useState({
    type: "success",
    message: "",
  });
  useEffect(() => {
    const token = storage.get("xAuthToken");
    if (token) {
      navigate("/home", { replace: true });
    }
  }, []);

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: (values, action) => {
        setLoading(true);
        dispatch(
          signupUser({
            body: {
              firstName: values.firstName,
              lastName: values.lastName,
              // phonenumber: "",
              email: values.email,
              password: values.password,
              role: "STUDENT",
            },
            onSuccess: (res) => {
              setLoading(false);
              if (res.data.data.role === "STUDENT") {
                navigate("/home", { replace: true });
              } else {
                navigate("/signup/createclass", { replace: true });
              }
              action.resetForm();
            },
            onError: (err) => {
              setLoading(false);
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                setErrorMessage({
                  type: "danger",
                  message: err.response.data.message,
                });
              }
            },
          })
        );
      },
    });

  // Student Signup
  /* const SignUp = () => {
    dispatch(signUpStudent({ firstName, lastName, email, password  }));
  }; */

  return (
    <div className="flex-container">
      <div
        // className="col-xxl-1 col-xl-1 col-lg-12 col-md-12 px-0"
        className="activity-spectrum"
      >
        <div>
          <DraggableSidebar
          /*  scrollBook={scrollToSection}
                  scrollCentre={scrollWithSpectrum} */
          />
        </div>
      </div>
      <div style={{ width: "97.9%" }}>
        <section className="class_room_wrap">
          <div className="custom_container">
            <div className="row">
              <div className="col-xxl-3 col-xl-5 col-lg-5 col-md-12 px-0   pb-0">
                <SideBar tabContents="class" />
              </div>
              <div
                className="col-xxl-6 col-xl-7 col-lg-7 col-md-12"
                style={{ marginTop: "72px" }}
              >
                <div className="welcome_wrap ">
                  <h1 className="main_title mb-4 pt-100 ">welcome</h1>
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="First name"
                            name="firstName"
                            value={values.firstName}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                          <div className="err-end">
                            {errors.firstName && touched.firstName ? (
                              <p className="error-msg">{errors.firstName}</p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last name"
                            name="lastName"
                            value={values.lastName}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            autoComplete="off"
                          />{" "}
                          <div className="err-end">
                            {errors.lastName && touched.lastName ? (
                              <p className="error-msg">{errors.lastName}</p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="University email address"
                            name="email"
                            value={values.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            autoComplete="off"
                          />{" "}
                          <div className="err-end">
                            {errors.email && touched.email ? (
                              <p className="error-msg">{errors.email}</p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            type="Password"
                            className="form-control"
                            name="password"
                            placeholder="Password"
                            value={values.password}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            autoComplete="off"
                          />{" "}
                          <div className="err-end">
                            {errors.password && touched.password ? (
                              <p className="error-msg">{errors.password}</p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <input
                            type="Password"
                            className="form-control"
                            placeholder="Confirm password"
                            name="confirmPassword"
                            value={values.confirmPassword}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            autoComplete="off"
                          />{" "}
                          <div className="err-end">
                            {errors.confirmPassword &&
                            touched.confirmPassword ? (
                              <p className="error-msg">
                                {errors.confirmPassword}
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      {/*                     {loading ? (
                      <div>
                        <div className="spinner"></div>
                      </div>
                    ) : ( */}
                      <div className="col-lg-12">
                        <div className="btn_Wrap mt-30">
                          <button
                            type="submit"
                            className="btn_black_theme w-100 d-block"
                            disabled={loading ? true : false}
                          >
                            {loading ? (
                              <div className="loader">
                                <Loader />
                              </div>
                            ) : (
                              "Sign up"
                            )}
                          </button>
                          <p className="agrre-to mt-20 pb-55">
                            By signing up, you agree to be contacted by greyled
                            and its partners.{" "}
                            <a
                              href="https://greyled.com/privacy-policy"
                              className="font-whi"
                            >
                              Learn more
                            </a>
                          </p>
                          <div>
                            {" "}
                            {errorMessage.message && (
                              <div
                                className={`alert alert-${errorMessage.type}`}
                              >
                                {errorMessage.message}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/*       )} */}

                      <div className="col-12">
                        <div className="footer_bottom">
                          <p className="have-account">
                            Already have an account?{" "}
                            <Link to={"/studentsignin"}>Sign in</Link>
                          </p>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- Option 1: Bootstrap Bundle with Popper --> */}
      </div>
    </div>
  );
}

export default StudentSignup;
